import { mapState } from 'vuex'
import Preloader from '../../Common/Preloader/Preloader'
import axios from 'axios'

export default {
  components: { Preloader },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  name: 'EditEmployee',
  data() {
    return {
      permissions: [],
      currentDivisionList: [],
      currentLocationsList: [],
      currentPositionList: [],
      isPreloader: true,
      isAdmin: false,
      pinCode: '',
      successMessage: '',
      menu1: false,
      menu2: false,
      selectDivision: '',
      selectPosition: '',
      selectLocation: '',
      date1: '',
      date2: '',
      messages: {
        division: '',
        position: '',
        location: ''
      },
      errors: {
        division: ''
      }
    }
  },
  destroyed() {
    this.permissions = []
    this.$store.commit('CLEAR_EMPLOYEE_INFO_FOR_EDIT')
  },
  mounted() {
    this.$store.dispatch('GET_EMPLOYEE_INFO_FOR_EDIT', this.id)
    // this.$store.dispatch('GET_DB_LIST')
    this.$store.dispatch('GET_DB_ACCESS_LIST')
    this.subscribeToMutations()
    this.getLocationList()
  },
  watch: {
    permissions: {
      deep: true,
      handler(val, oldVal) {
        if (JSON.stringify(val).length === JSON.stringify(oldVal).length) this.saveEditData()
      }
    },
    permissionsForEdit(val) {
      this.permissions = val
      this.isPreloader = false
    },
    admin(val) {
      this.isAdmin = !!val
    },
    pinCode(val) {
      if (val.length === 4) {
        this.loading = true
        this.saveEditData()
        this.successMessage = ''
      }
    },
    isAdmin() {
      this.saveEditData()
    },
    organisationId(val) {
      this.getDivisionsByInn(val)
    },
    currentDivisionList(val) {
      const divisionName = this.$store.state.employee.employeeInfoForEdit.division
      const locationName = this.$store.state.employee.employeeInfoForEdit.locationName

      if (divisionName !== 'Подразделение не назначено') {
        this.selectDivision = val.filter(item => item.name === divisionName)[0].id
      } else {
        this.messages.division = divisionName
      }

      if (locationName !== 'Локация не назначена') {
        this.selectLocation = this.currentLocationsList.filter(
          item => item.name === locationName
        )[0].id
      } else {
        this.messages.location = locationName
      }
    },
    selectDivision(val, oldVal) {
      this.getPositionList(val)
      this.messages.division = ''

      if (val && val !== oldVal) {
        // console.log('val-division: ', val)
        this.saveEditData()
      }
    },
    selectLocation(val, oldVal) {
      this.messages.location = ''
      if (val && val !== oldVal) {
        // console.log('val-location: ', val)
        this.saveEditData()
      }
    },
    selectPosition(val, oldVal) {
      this.messages.position = ''
      if (val && val !== oldVal) {
        // console.log('val-position: ', val)
        this.saveEditData()
      }
    },
    currentPositionList(val) {
      const positionName = this.$store.state.employee.employeeInfoForEdit.position
      if (positionName !== 'Должность не назначена') {
        this.selectPosition = val.filter(item => item.position === positionName)[0].id
      } else {
        this.messages.position = positionName
      }
    },
    appointmentDate(val) {
      this.date1 = val
    },
    dismissalDate(val) {
      this.date2 = val
    },
    date1(val, oldVal) {
      if (val && val !== oldVal) {
        this.saveEditData()
      }
    },
    date2(val, oldVal) {
      if (val && val !== oldVal) {
        this.saveEditData()
      }
    }
  },
  computed: {
    ...mapState({
      viewInn: state => state.employee.employeeInfoForEdit.inn,
      viewName: state => state.employee.employeeInfoForEdit.name,
      viewOrgInn: state => state.employee.employeeInfoForEdit.organisationInn,
      viewOrgName: state => state.employee.employeeInfoForEdit.organisationName,
      organisationId: state => state.employee.employeeInfoForEdit.organisationId,
      appointmentDate: state => state.employee.employeeInfoForEdit.appointmentDate,
      dismissalDate: state => state.employee.employeeInfoForEdit.dismissalDate,
      permissionsForEdit: state => state.employee.employeeInfoForEdit.permissions,
      admin: state => state.employee.employeeInfoForEdit.isAdmin,
      pin: state => state.employee.employeeInfoForEdit.localPin,
      editEmployeeLoading: state => state.employee.loading.editEmployeeLoading,
      dbAccessList: state => state.employee.dbAccessList
    }),
    classifierAccessList() {
      return this.$store.getters.classifierAccessList
    }
  },
  methods: {
    cancel() {
      this.$router.push({ path: '/main/employee/list' })
      this.permissions = []
      this.$store.commit('CLEAR_EMPLOYEE_INFO_FOR_EDIT')
    },
    saveEditData() {
      let data = {
        id: this.id,
        payload: {
          localPin: this.pinCode,
          isAdmin: this.isAdmin,
          locationId: this.selectLocation
            ? this.selectLocation
            : '00000000-0000-0000-0000-000000000000',
          divisionId: this.selectDivision
            ? this.selectDivision
            : '00000000-0000-0000-0000-000000000000',
          positionId: this.selectPosition
            ? this.selectPosition
            : '00000000-0000-0000-0000-000000000000',
          appointmentDate: this.date1,
          dismissalDate: this.date2,
          permissions: this.permissions
        }
      }
      this.$store.dispatch('EDIT_EMPLOYEE', data).then(() => {
        this.pinCode = ''
      })
    },
    subscribeToMutations() {
      this.$store.subscribe((mutation, state) => {
        switch (mutation.type) {
          case 'EDIT_EMPLOYEE_SUCCESS':
            let answer = this.$store.state.employee.editEmployeeAnswer
            if (answer.code === 'PinChanged') {
              this.successMessage = answer.message
            }
            break
          case 'EDIT_EMPLOYEE_ERROR':
            break
        }
      })
    },
    getDivisionsByInn(id) {
      axios({
        method: 'GET',
        url: `/api/Division/list/${id}`
      })
        .then(response => {
          // console.log(response.data)
          this.currentDivisionList = response.data.result
        })
        .catch(error => {
          console.log(error.response.data.message)
          this.errors.division = error.response.data.message
        })
    },
    getLocationList() {
      axios({
        method: 'GET',
        url: '/api/Location/list'
      })
        .then(response => {
          // console.log(response.data)
          this.currentLocationsList = response.data.result
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    getPositionList(divisionId) {
      axios({
        method: 'GET',
        url: '/api/Position/list',
        params: { divisionId }
      })
        .then(response => {
          // console.log(response.data)
          this.currentPositionList = response.data.result
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Employees/EditEmployee/EditEmployee.js